var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useReport } from '@tencent/dz-report';
export var useReportService = function (_a) {
    var _b = _a.questions, questions = _b === void 0 ? [] : _b, visible = _a.visible;
    var report = useReport();
    var questionsStr = questions.join(',');
    var moduleParams = {
        module_value: questionsStr,
        module_type: 'retain_popup',
        module_chinese_type: '挽留弹窗',
    };
    React.useEffect(function () {
        if (visible) {
            report.exposure(__assign(__assign({}, moduleParams), { element_chinese_type: '挽留弹窗', element_id: questionsStr, element_type: 'retain_popup', element_content: questionsStr }));
        }
    }, [visible]);
    var questionClickReport = function (question) {
        report.click(__assign(__assign({}, moduleParams), { element_chinese_type: '问题', element_id: question, element_type: 'question', element_content: question }));
    };
    var leaveReport = function (btnContent) {
        report.click(__assign(__assign({}, moduleParams), { element_chinese_type: '确认', element_id: btnContent, element_type: 'confirm', element_content: btnContent }));
    };
    var cancelReport = function (btnContent) {
        report.click(__assign(__assign({}, moduleParams), { element_chinese_type: '取消', element_id: btnContent, element_type: 'cancel', element_content: btnContent }));
    };
    return {
        questionClickReport: questionClickReport,
        leaveReport: leaveReport,
        cancelReport: cancelReport,
        moduleParams: moduleParams,
    };
};
